import type {
  AgentRoleAssetKind,
  AgentRoleAssetRow,
  AgentRoleAssetScope,
  AgentRoleAssetStatus,
} from '../../apps/apis/claudeCodeDashboard/types';

export const ROLE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'content-influencer-marketing', label: 'Content & Influencer Marketing' },
  { value: 'growth-data', label: 'Growth & Data' },
  { value: 'category', label: 'Category' },
  { value: 'brand-partnership', label: 'Brand Partnership' },
  { value: 'fulfillment-cs', label: 'Fulfillment + CS' },
  { value: 'design', label: 'Design' },
  { value: 'finance-hr', label: 'Finance + HR' },
  { value: 'development', label: 'Development' },
];

export const KIND_OPTIONS: Array<{ value: '' | AgentRoleAssetKind; label: string }> = [
  { value: '', label: 'All kinds' },
  { value: 'skill', label: 'Skill' },
  { value: 'agent', label: 'Agent' },
  { value: 'hook', label: 'Hook' },
  { value: 'instruction', label: 'Instruction' },
  { value: 'mcp_preset', label: 'MCP preset' },
];

export const SCOPE_OPTIONS: Array<{ value: '' | AgentRoleAssetScope; label: string }> = [
  { value: '', label: 'All scopes' },
  { value: 'role', label: 'Single role' },
  { value: 'multi_role', label: 'Multiple roles' },
  { value: 'company_wide', label: 'Company-wide' },
];

export const STATUS_OPTIONS: Array<{ value: '' | AgentRoleAssetStatus; label: string }> = [
  { value: '', label: 'All statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'active', label: 'Active' },
  { value: 'retired', label: 'Retired' },
];

export const statusVariant = (status: AgentRoleAssetStatus) => {
  switch (status) {
    case 'active':
      return 'success';
    case 'draft':
      return 'warning';
    case 'retired':
      return 'secondary';
  }
};

export const scopeLabel = (scope: AgentRoleAssetScope) => {
  switch (scope) {
    case 'role':
      return 'Single role';
    case 'multi_role':
      return 'Multiple roles';
    case 'company_wide':
      return 'Company-wide';
  }
};

export const kindLabel = (kind: AgentRoleAssetKind) => {
  const option = KIND_OPTIONS.find((item) => item.value === kind);
  return option?.label ?? kind;
};

export const roleLabel = (role: string) => ROLE_OPTIONS.find((item) => item.value === role)?.label ?? role;

export const formatDate = (value: string | null) => (value ? new Date(value).toLocaleString() : '-');

export const formatCount = (value: number | null | undefined) => (value ?? 0).toLocaleString();

export const formatCost = (value: number | null | undefined) => `$${(value ?? 0).toFixed(2)}`;

export const metricHealthVariant = (asset: AgentRoleAssetRow) => {
  if (asset.metrics.failedCount > 0) {
    return 'danger';
  }
  if (asset.status === 'active' && asset.metrics.usageCount === 0) {
    return 'warning';
  }
  if (asset.metrics.usageCount > 0) {
    return 'success';
  }
  return 'secondary';
};

export const roleSummary = (asset: AgentRoleAssetRow) => {
  if (asset.scope === 'company_wide') {
    return 'Company-wide';
  }
  return asset.roles.length ? asset.roles.map(roleLabel).join(', ') : '-';
};
